import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemContentBase } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-base';
import { FiDateTimeFormatOptions, getObjectTypeNameTextId } from '@fi-shared/utils';
import { INewsFeedBalooSyncItem } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-news-feed-item-content-baloo',
    templateUrl: './news-feed-item-content-baloo.component.html',
    styleUrls: ['./news-feed-item-content-baloo.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-item-content-baloo' },
    standalone: false,
})
export class NewsFeedItemContentBalooComponent extends NewsFeedItemContentBase {
    getBalooLogFeedItemTitle() {
        const changedOn = this.fiFormatDateService.formatDate(this.newsItem.ChangedOn, FiDateTimeFormatOptions, {
            showToday: false,
        });
        return this.appTextService.get('baloo.news_feed_title', {
            '{0}': changedOn,
        });
    }

    getBalooSyncItems(): INewsFeedBalooSyncItem[] {
        return this.newsItem.Content.BalooSyncItems;
    }

    getBalooSyncLogStateParams(balooSyncItem: INewsFeedBalooSyncItem) {
        return {
            selectedSyncLogId: balooSyncItem.Id,
            selectedTabIndex: this.getTabIndexByObjectType(balooSyncItem.ObjectType),
        };
    }

    getBalooLogFeedItemErrorText(balooSyncItem: INewsFeedBalooSyncItem) {
        const objectTypeNameTextId = getObjectTypeNameTextId(balooSyncItem.ObjectType, balooSyncItem.FailedCount !== 1);
        const objectTypeName = this.appTextService.get(objectTypeNameTextId);
        if (balooSyncItem.ErrorMessage) {
            return objectTypeName + ': ' + this.appTextService.get('baloo.news_feed_unexpected_error');
        }
        return this.appTextService.get('baloo.news_feed_failed_items_error', {
            '{object_type_name}': objectTypeName.toLowerCase(),
            '{n}': balooSyncItem.FailedCount,
        });
    }

    private getTabIndexByObjectType(objectType: ObjectTypes) {
        if (objectType === ObjectTypes.BusinessUnit) return 0;
        if (objectType === ObjectTypes.Role) return 1;
        if (objectType === ObjectTypes.User) return 2;
        throw new Error(`getTabIndexByObjectType: unknown object type ${objectType}`);
    }
}
